// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// KEY VALUE SCHEMA
/////////////////////////////////////////

export const KeyValueSchema = z.object({
  key: z.string(),
  value: z.string(),
})

export type KeyValue = z.infer<typeof KeyValueSchema>

export default KeyValueSchema;
